import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-googleveo31',
  templateUrl: './googleveo31.component.html',
  styleUrls: ['./googleveo31.component.scss']
})
export class Googleveo31Component {
  constructor(private dialogRef: MatDialogRef<Googleveo31Component>) {}

  close(): void {
    this.dialogRef.close();
  }
}
